import { useState } from "react";
import "./editorialForms.css";

export default function VotingForm({ data, onChange }) {
  const [optionInput, setOptionInput] = useState("");

  const votingTypes = [
    { id: "poll", name: "Enquete" },
    { id: "survey", name: "Pesquisa" },
    { id: "election", name: "Eleição" },
    { id: "decision", name: "Decisão Coletiva" },
    { id: "feedback", name: "Feedback" },
    { id: "rating", name: "Avaliação" },
  ];

  const resultVisibility = [
    { id: "always", name: "Sempre visível" },
    { id: "after_vote", name: "Após votar" },
    { id: "after_end", name: "Após encerramento" },
    { id: "never", name: "Apenas para criador" },
  ];

  const handleAddOption = () => {
    if (optionInput.trim()) {
      onChange({
        ...data,
        options: [
          ...(data?.options || []),
          { text: optionInput.trim(), votes: 0 },
        ],
      });
      setOptionInput("");
    }
  };

  const handleRemoveOption = (index) => {
    onChange({
      ...data,
      options: (data?.options || []).filter((_, i) => i !== index),
    });
  };

  const handleUpdateOption = (index, text) => {
    const newOptions = [...(data?.options || [])];
    newOptions[index] = { ...newOptions[index], text };
    onChange({ ...data, options: newOptions });
  };

  return (
    <div className="editorial_form voting_form">
      <div className="editorial_form_section">
        <label>
          Pergunta/Título <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Qual o melhor dia para a reunião?"
          value={data?.question || ""}
          onChange={(e) => onChange({ ...data, question: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descrição (opcional)</label>
        <textarea
          placeholder="Adicione mais contexto sobre a votação..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={500}
          rows={2}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Tipo de Votação</label>
          <select
            value={data?.votingType || "poll"}
            onChange={(e) => onChange({ ...data, votingType: e.target.value })}
          >
            {votingTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Visibilidade dos Resultados</label>
          <select
            value={data?.resultVisibility || "after_vote"}
            onChange={(e) =>
              onChange({ ...data, resultVisibility: e.target.value })
            }
          >
            {resultVisibility.map((vis) => (
              <option key={vis.id} value={vis.id}>
                {vis.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Opções de Voto ({(data?.options || []).length})
          <span className="required">*</span>
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddOption}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Digite uma opção..."
          value={optionInput}
          onChange={(e) => setOptionInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddOption()}
        />
        <div style={{ marginTop: "8px" }}>
          {(data?.options || []).map((opt, i) => (
            <div key={i} className="variant_row">
              <span className="option_number">{i + 1}.</span>
              <input
                type="text"
                value={opt.text}
                onChange={(e) => handleUpdateOption(i, e.target.value)}
                placeholder="Texto da opção"
              />
              <button
                type="button"
                className="remove_variant_btn"
                onClick={() => handleRemoveOption(i)}
              >
                ×
              </button>
            </div>
          ))}
        </div>
        {(data?.options || []).length < 2 && (
          <span className="editorial_form_hint">
            Adicione pelo menos 2 opções para criar a votação.
          </span>
        )}
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Data de Início</label>
          <input
            type="datetime-local"
            value={data?.startDate || ""}
            onChange={(e) => onChange({ ...data, startDate: e.target.value })}
          />
          <span className="editorial_form_hint">
            Deixe em branco para começar imediatamente
          </span>
        </div>

        <div className="editorial_form_section">
          <label>Data de Encerramento</label>
          <input
            type="datetime-local"
            value={data?.endDate || ""}
            onChange={(e) => onChange({ ...data, endDate: e.target.value })}
          />
          <span className="editorial_form_hint">
            Deixe em branco para não ter prazo
          </span>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Máximo de Votos por Pessoa</label>
        <input
          type="number"
          min="1"
          max="10"
          placeholder="1"
          value={data?.maxVotesPerUser || 1}
          onChange={(e) =>
            onChange({
              ...data,
              maxVotesPerUser: parseInt(e.target.value) || 1,
            })
          }
        />
      </div>

      <div className="editorial_form_section">
        <label>Configurações</label>
        <div className="editorial_form_checkboxes">
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="isAnonymous"
              checked={data?.isAnonymous || false}
              onChange={(e) =>
                onChange({ ...data, isAnonymous: e.target.checked })
              }
            />
            <label htmlFor="isAnonymous">Votação anônima</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="allowMultiple"
              checked={data?.allowMultiple || false}
              onChange={(e) =>
                onChange({ ...data, allowMultiple: e.target.checked })
              }
            />
            <label htmlFor="allowMultiple">Permitir múltiplas escolhas</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="allowChangeVote"
              checked={data?.allowChangeVote !== false}
              onChange={(e) =>
                onChange({ ...data, allowChangeVote: e.target.checked })
              }
            />
            <label htmlFor="allowChangeVote">Permitir alterar voto</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="showVoterCount"
              checked={data?.showVoterCount !== false}
              onChange={(e) =>
                onChange({ ...data, showVoterCount: e.target.checked })
              }
            />
            <label htmlFor="showVoterCount">Mostrar contagem de votos</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="requireLogin"
              checked={data?.requireLogin !== false}
              onChange={(e) =>
                onChange({ ...data, requireLogin: e.target.checked })
              }
            />
            <label htmlFor="requireLogin">Exigir login para votar</label>
          </div>
        </div>
      </div>

      <div className="editorial_form_tip voting_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M18 13h-.68l-2 2h1.91L19 17H5l1.78-2h2.05l-2-2H6l-3 3v4c0 1.1.89 2 1.99 2H19a2 2 0 0 0 2-2v-4l-3-3zm-1-5.05l-4.95 4.95-3.54-3.54 4.95-4.95L17 7.95zm-4.24-5.66L6.39 8.66a.996.996 0 0 0 0 1.41l4.95 4.95c.39.39 1.02.39 1.41 0l6.36-6.36a.996.996 0 0 0 0-1.41L14.16 2.3a.975.975 0 0 0-1.4-.01z" />
        </svg>
        <span>
          Crie enquetes e votações para engajar sua audiência. Configure
          anonimato e visibilidade dos resultados.
        </span>
      </div>
    </div>
  );
}
